/* eslint-disable */
export default {
  'th-TH': {
    common: {
      NAME_HOLDER: "ชื่อ *",
      LAST_NAME_HOLDER: "นามสกุล *",
      EMAIL_HOLDER: "อีเมล *",
      PASS_HOLDER: "สร้างรหัสผ่าน *",
      REPEAT_PASS_HOLDER: "ใส่รหัสผ่านซ้ำ *",
      BUTTON_EMAIL_SIGN_UP: "ลงทะเบียนด้วยอีเมล",

      TERMS_AND_CONDITIONS: "Terms and Conditions",
      PRIVACY_POLICY: "Privacy Policy",

      NEWSLETTER_CONSENT: "ฉันยินยอมที่จะรับอีเมลจาก Time Out เกี่ยวกับข่าวสารล่าสุด, อีเวนต์, ข้อเสนอพิเศษ และโปรโมชันร่วมกับแบรนด์อื่นๆ",
      TERM_OF_USE: "ฉันยอมรับข้อกำหนดและเงื่อนไขของ Time Out ซึ่งรวมถึงการยอมรับจดหมายข่าว",
      TERM_OF_USE_WITH_NEWSLETTERS: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out, including opt-in to newsletters",

      HEADER_TITLE: "สร้างบัญชี Time Out",
      JOIN_FB: "สมัครด้วย Facebook",
      JOIN_TW: "สมัครด้วย Twitter",
      JOIN_GG: "สมัครด้วย Google",
      JOIN_EM: "สมัครด้วยอีเมล",
      ALREADY_HAVE: "มีบัญชี Time Out อยู่แล้ว?",
      CREATE_ACCOUNT_LOG_IN: "เข้าสู่ระบบ",

      SIGN_IN_TITLE: "ลงชื่อเข้าใช้",
      SIGN_IN_FB: "ลงชื่อเข้าใช้ด้วยบัญชี Facebook",
      SIGN_IN_TW: "ลงชื่อเข้าใช้ด้วยบัญชี Twitter",
      SIGN_IN_GG: "ลงชื่อเข้าใช้ด้วยบัญชี Google",
      SIGN_IN_EM: "ลงชื่อเข้าใช้ด้วยอีเมล",
      YOUR_EMAIL: "อีเมลของคุณ",
      YOUR_PASSWORD: "รหัสผ่านของคุณ",
      REMEMBER: "จดจำบัญชีของฉัน",
      FORGOT: "ลืม?",
      HAVE_ACCOUNT_YET: "ฉันยังไม่มีบัญชี Time Out?",
      JOIN_HERE: "สมัครที่นี่",
      ALMOST_THERE: "เกือบจะมี",

      FORGOT_HEADER: "ลืมรหัสผ่าน?",
      FORGOT_SUBTITLE: "ไม่มีปัญหา เพียงแค่คุณใส่ที่อยู่อีเมลของคุณด้านล่าง เราจะส่งลิงก์ไปให้คุณเพื่อเปลี่ยนรหัสผ่าน",
      SEND_LINK: "ส่งลิงก์",

      RECEIVE_EMAIL: "ขอบคุณค่ะ คุณจะได้รับอีเมลจากเราเร็วๆนี้",
      MANAGE_ACCOUNT: "จัดการบัญชีของคุณ",
      EDIT_DETAILS_HERE: "แก้ไขบัญชีของคุณที่นี่",
      FIRST_NAME: "ชื่อ",
      LAST_NAME: "นามสกุล",
      SCREEN_NAME: "ชื่อบัญชี",
      EMAIL: "อีเมล",
      ACCOUNT_DETAILS: "รายละเอียดบัญชี",
      PASSWORD: "รหัสผ่าน",
      SAVE_CHANGES: "บันทึกการเปลี่ยนแปลง",
      UPLOAD_PIC: "อัพโหลดภาพโปรไฟล์",
      CHOOSE_PHOTO: "เลือกภาพจากอุปกรณ์ของคุณ ภาพต้องมีขนาดไม่เกิน 2 เมกะไบต์",
      CLOSE_ACCOUNT: "ปิดบัญชีของฉัน",
      PASSWORD_BELOW: "เปลี่ยนรหัสผ่านที่นี่",
      CURRENT_PASSWORD: "รหัสผ่านปัจจุบัน",
      NEW_PASSWORD: "รหัสผานใหม่",
      REPEAT_PASSWORD: "ใส่รหัสผ่านซ้ำ",

      OOPS: "อุปส์!",
      ERROR_404_OCCURED: "มีข้อผิดพลาดเกืดขึ้น",
      ERROR_404_INFO: "หน้าที่คุณค้นหาอาจถูกย้ายไปที่อยู่ใหม่หรือถูกลบไปแล้ว",
      ERROR_500_TITLE: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้",
      SMTH_BROKEN: "บางอย่างมีข้อผิดพลาดหรือเกิดความเสียหาย",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "กรุณาระบุสิ่งที่คุณกำลังทำเมื่อเกิดข้อผิดพลาดนี้ขึ้น เราจะแก้ไขปัญหาโดยเร็วที่สุด ขออภัยในความไม่สะดวกมา ณ ที่นี้ค่ะ",
      ERROR_500_INFO: "กรุณาระบุสิ่งที่คุณกำลังทำเมื่อเกิดข้อผิดพลาดนี้ขึ้น เราจะแก้ไขปัญหาโดยเร็วที่สุด ขออภัยในความไม่สะดวกมา ณ ที่นี้ค่ะ",

      EMAIL_ERROR: "กรุณาระบุที่อยู่อีเมล",
      PASSWORD_ERROR: "กรุณาใส่รหัสผ่าน",
      FIRST_NAME_ERROR: "กรุณากรอกชื่อของคุณ",
      LAST_NAME_ERROR: "โปรดใส่นามสกุลของคุณ",
      TERM_OF_USE_ERROR: "คุณต้องยอมรับข้อกำหนดในการให้บริการของเรา",
      SIGN_IN_VALIDATION_ERROR: "รหัสผ่านผิดพลาดหรือไม่ถูกต้อง - กรุณาลองอีกครั้ง",
      ACCOUNT_PASSWORDS_VALIDATION: "รหัสผ่านไม่เหมือนกัน",
      WAS_IT: "เป็นความผิดพลาดที่เกิดจากทางเรา?",
      DELETE_ACCOUNT_TEXT: "เราเสียใจที่คุณต้องการจะลบบัญชีของคุณ ไม่ทราบว่าคุณจะสามารถระบุสาเหตุที่ทำให้คุณอยากลบบัญชีได้ไหมคะ?",
      DELETE_ACCOUNT: "ลบบัญชี",
      CANCEL: "ยกเลิก",

      UPDATE_PASSWORD: "อัปเดตรหัสผ่านของคุณ",
      PASSWORD_UPDATE_SUCCESS: "อัปเดตรหัสผ่านของคุณแล้ว",
      ERROR_PASSWORD_LENGTH: "รหัสผ่านต้องมีอักขระอย่างน้อย 6 ตัว",

      ERROR_MISSING_SITE_PARAMETER: "ไม่มีพารามิเตอร์แอ็พพลิเคชันที่ต้องการ: site",
      ERROR_ALREADY_REGISTERED: "คุณลงทะเบียนแล้วโดยใช้การลงทะเบียนอีเมล กรุณาเข้าสู่ระบบโดยใช้ {{email}}",
    },
    'th-bangkok': {
      TERM_OF_USE: '<a class="xs-text-red cursor-pointer" href="https://www.timeout.com/bangkok/th/ข้อตกลงและเงื่อนไข" target="_blank">' +
      "ฉันยอมรับข้อกำหนดและเงื่อนไขของ Time Out ซึ่งรวมถึงการยอมรับจดหมายข่าว</a>",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/th-TH.js